import React from 'react';
import Logo from '../../Logo/Logo';
import NavigationItems from '../NavigationItems/NavigationItems';
import classes from './SideDrawer.module.css';
import Wrapper from '../../../../wrapper/Wrapper';
import BackDrop from '../../Backdrop/backdrop';


const Sidedrawer = (props) => {
    let sideDrawerClas = [classes.SideDrawer , classes.Close];
    const fina = props.show ? [classes.SideDrawer , classes.Open] : sideDrawerClas; 
    return (
        <Wrapper>
            <BackDrop show={props.show} dropBackDrop={props.toggle}/>
            <div className={fina.join(' ')} >
                <Logo value={{marginLeft:'92px'}}/>
                <nav>
                    <NavigationItems shouldShowOtherLinks={props.isLoggedIn}>
                        
                    </NavigationItems>
                </nav>
            </div>
        </Wrapper>
    );
}

export default Sidedrawer;